export default __webpack_public_path__ + "static/media/Group pc.04844fb0.png";